import React from 'react';

import { CarMakeSelectOptionProps } from './CarMakeSelectOption.interface';
import { CarMakeLogo } from 'app/components/CarMakeLogo';
import { StepSelectControlOptionWithIcon } from 'app/components/StepSelectControlOptionWithIcon';

export default function CarMakeSelectOption({
  value,
}: CarMakeSelectOptionProps) {
  return (
    <StepSelectControlOptionWithIcon
      label={value}
      icon={<CarMakeLogo carMakeDictionaryEntryValue={value} />}
    />
  );
}
